<template>
  <div class="myProjects">
    <div class="d-lg-none text-center">
      <div class="mb-4 mobile-home-options">
        <b-form-radio-group
           id="mobile-home-selection"
           buttons
           stacked
           button-variant="outline-primary"
           @change="selectTile"
           :options="mobileOptions"
           name="mobileOptions">
        </b-form-radio-group>
      </div>
    </div>
    <div class="d-none d-lg-block">
      <div class="row home-page-tile-row">
        <div class="col-6">
          <div class="card">
            <div class="card-body"
              v-bind:class="{ homeTileCard: userOpenServices && userOpenServices.length > 0,
                              selectedHomeTileCard:
                                selectedEntityType === 'openServicesStaffLeading' }"
              @click="selectTile('openServicesStaffLeading')"
              >
              <div class="text-right">
                <PlusMinusControl
                   entityName="'Open Services Staff Leading'"
                   :entities="userOpenServices"
                   :isActive="selectedEntityType === 'openServicesStaffLeading'"
                 />
              </div>
              <div class="home-page-tile-primary-text"
                v-bind:class="{ selectedHomeTileCard:
                                  selectedEntityType === 'openServicesStaffLeading' }">
                <LoadingSpinner v-if="userOpenServicesLoading" message="" size='1x' />
                <template v-else>
                  {{ userOpenServices.length }}
                </template>
              </div>
              <div class="home-page-tile-secondary-text"
                v-bind:class="{ selectedHomeTileCard:
                                  selectedEntityType === 'openServicesStaffLeading' }">
                My Open Services
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card">
            <div class="card-body"
                 v-bind:class="{ homeTileCard:
                                   userReviews && userReviews.length > 0,
                 selectedHomeTileCard: selectedEntityType === 'openReview' }"
                 @click="selectTile('openReview')"
              >
              <div class="text-right">
                <PlusMinusControl
                   entityName="'Open Services For Review'"
                   :entities="userReviews"
                   :isActive="selectedEntityType === 'openReview'"
                 />
              </div>
              <div class="home-page-tile-primary-text"
                   v-bind:class="{ selectedHomeTileCard:
                                     selectedEntityType === 'openReview' }"
                   >
                <LoadingSpinner v-if="userReviewsLoading" message="" size='1x' />
                <template v-else>
                  {{ userReviews.length }}
                </template>
              </div>
              <div class="home-page-tile-secondary-text"
                   v-bind:class="{ selectedHomeTileCard:
                                     selectedEntityType === 'openReview' }"
                   >
                My Pending Reviews
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row home-page-tile-row">
        <div class="col-6">
          <div class="card">
            <div class="card-body"
              v-bind:class="{ homeTileCard:
                                userStaffLeadInstruments && userStaffLeadInstruments.length > 0,
              selectedHomeTileCard: selectedEntityType === 'pendingInstrumentsStaffLeading' }"
              @click="selectTile('pendingInstrumentsStaffLeading')">
              <div class="text-right">
                <PlusMinusControl
                   entityName="'Pending Instruments Staff Leading'"
                   :entities="userStaffLeadInstruments"
                   :isActive="selectedEntityType === 'pendingInstrumentsStaffLeading'"
                 />
              </div>
              <div class="home-page-tile-primary-text"
                v-bind:class="{ selectedHomeTileCard:
                                  selectedEntityType === 'pendingInstrumentsStaffLeading' }">
                <LoadingSpinner v-if="userStaffLeadInstrumentsLoading" message="" size='1x' />
                <template v-else>
                  {{ userStaffLeadInstruments.length }}
                </template>
              </div>
              <div class="home-page-tile-secondary-text"
                v-bind:class="{ selectedHomeTileCard:
                                  selectedEntityType === 'pendingInstrumentsStaffLeading' }">
                My Pending Instruments
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card">
            <div class="card-body"
                 v-bind:class="{ homeTileCard:
                                   userReviewsAssignedByMe && userReviewsAssignedByMe.length > 0,
                 selectedHomeTileCard: selectedEntityType === 'reviewsAssigned' }"
                 @click="selectTile('reviewsAssigned')"
              >
              <div class="text-right">
                <PlusMinusControl
                   entityName="'Reviews Assigned by Me'"
                   :entities="userReviewsAssignedByMe"
                   :isActive="selectedEntityType === 'reviewsAssigned'"
                 />
              </div>
              <div class="home-page-tile-primary-text"
                   v-bind:class="{ selectedHomeTileCard:
                                     selectedEntityType === 'reviewsAssigned' }"
                   >
                <LoadingSpinner v-if="userReviewsAssignedByMeLoading" message="" size='1x' />
                <template v-else>
                  {{ openReviewsCount(userReviewsAssignedByMe) }}
                </template>
              </div>
              <div class="home-page-tile-secondary-text"
                   v-bind:class="{ selectedHomeTileCard:
                                     selectedEntityType === 'reviewsAssigned' }"
                   >
                Reviews Assigned by Me
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="component-fade" mode="out-in">
      <component
        v-if="selectedEntityType"
        :is="entityTypes[selectedEntityType].listComponent"
        :entities="selectedEntities"
        :entityName="selectedEntityName"
        :loading="selectedEntitiesLoading"
        :selectedType="selectedEntityType"
        :formatIdString="selectedEntityIdFormatter"
      />
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import MyInstruments from '@/components/instrument/MyInstruments.vue';
import MyReviews from '@/components/common/MyReviews.vue';
import MyReviewsAssigned from '@/components/common/MyReviewsAssigned.vue';
import MyServices from '@/components/service/MyServices.vue';
import PlusMinusControl from '@/components/common/PlusMinusControl.vue';

export default {
  name: 'MyProjects',
  components: {
    LoadingSpinner,
    MyInstruments,
    MyReviews,
    MyServices,
    PlusMinusControl,
  },
  data() {
    return {
      mobileOptions: [
        { text: 'My Open Services', value: 'openServicesStaffLeading' },
        { text: 'My Pending Reviews', value: 'openReview' },
        { text: 'My Pending Instruments', value: 'pendingInstrumentsStaffLeading' },
        { text: 'Reviews Assigned by Me', value: 'reviewsAssigned' },
      ],
      selectedEntities: [],
      selectedEntityName: '',
      selectedEntitiesLoading: false,
      selectedEntityType: '',
      selectedEntityIdFormatter: null,
      entityTypes: {
        openServicesStaffLeading: {
          listComponent: MyServices,
          entities: 'userOpenServices',
          entityName: 'Service',
          loading: 'userOpenServicesLoading',
          idFormatter: this.formatServiceId,
        },
        openReview: {
          listComponent: MyReviews,
          entities: 'userReviews',
          entityName: 'Review',
          loading: 'userReviewsLoading',
          idFormatter: this.formatReviewId,
        },
        reviewsAssigned: {
          listComponent: MyReviewsAssigned,
          entities: 'userReviewsAssignedByMe',
          entityName: 'Review',
          loading: 'userReviewsAssignedByMeLoading',
          idFormatter: this.formatReviewId,
        },
        pendingInstrumentsStaffLeading: {
          listComponent: MyInstruments,
          entities: 'userStaffLeadInstruments',
          entityName: 'Instrument',
          loading: 'userStaffLeadInstrumentsLoading',
          idFormatter: this.formatInstrumentId,
        },
      },
    };
  },
  mounted() {
    // dispatch actions to populate vuex state for this page
    this.$store.dispatch('Service/fetchOpenServicesForCurrentUser');
    this.$store.dispatch('Review/fetchReviewsForCurrentUser');
    this.$store.dispatch('Review/fetchReviewsAssignedBy');
    this.$store.dispatch('Instrument/fetchPendingInstrumentsForCurrentUser');
    this.$store.dispatch(`${LookupModules.INSTRUMENT_TYPES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_TYPES.url);
  },
  props: {
  },
  computed: {
    ...mapState('Service', {
      userOpenServices: state => state.userStaffLeadServices,
      userOpenServicesLoading: state => state.userStaffLeadServicesLoading,
    }),
    ...mapState('Instrument', {
      userStaffLeadInstruments: state => state.userStaffLeadInstruments,
      userStaffLeadInstrumentsLoading: state => state.userStaffLeadInstrumentsLoading,
    }),
    ...mapState('Review', {
      userReviews: state => state.userReviews,
      userReviewsLoading: state => state.userReviewsLoading,
      userReviewsAssignedByMe: state => state.userReviewsAssignedByMe,
      userReviewsAssignedByMeLoading: state => state.userReviewsAssignedByMeLoading,
    }),
    ...mapGetters(LookupModules.SERVICE_CATEGORIES.namespace, {
      getServiceCategoryName: 'getName',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_TYPES.namespace, {
      getInstrumentTypeProperty: 'getProperty',
    }),
  },
  methods: {
    formatServiceReviewId(serviceReview) {
      return `${serviceReview.serviceId} - ${this.getServiceCategoryName(serviceReview.service.categoryId)}`;
    },
    formatInstrumentReviewId(instrumentReview) {
      if (instrumentReview.instrument.typeId) {
        return `${instrumentReview.instrumentId} -
          ${this.getInstrumentTypeProperty(instrumentReview.instrument.typeId, 'code')}`;
      }
      return `${instrumentReview.instrumentId}`;
    },
    formatReviewId(review) {
      if (review.instrumentId) {
        return `(I) ${review.instrumentId}`;
      }
      return `(S) ${review.serviceId} - ${this.getServiceCategoryName(review.service.categoryId)}`;
    },
    formatInstrumentId(instrument) {
      if (instrument.typeId) {
        return `${instrument.id} - ${this.getInstrumentTypeProperty(instrument.typeId, 'code')}`;
      }
      return `${instrument.id}`;
    },
    selectTile(entitySelection) {
      this.selectedEntities = this[this.entityTypes[entitySelection].entities];
      this.selectedEntityName = this.entityTypes[entitySelection].entityName;
      this.selectedEntitiesLoading = this[this.entityTypes[entitySelection].loading];
      this.selectedEntityIdFormatter = this.entityTypes[entitySelection].idFormatter;
      if (this.selectedEntityType === entitySelection) {
        this.selectedEntityType = '';
      } else {
        this.selectedEntityType = entitySelection;
      }
    },
    openReviewsCount(reviews) {
      return reviews.filter(review => review.reviewStatusId === 1).length;
    },
  },
};
</script>
